import type { IntlShape } from 'react-intl'
import type { Question } from '../types'

/**
 * The three questions a visitor can answer on the marketing page: the opening
 * questions of a fictional questionnaire d'accueil for a parcours d'insertion.
 * Resolved through the message catalogs at render time so the public site
 * follows the UI locale. Used by DemoSurvey inside the parcours section.
 */

export function buildDemoQuestions(intl: IntlShape): Question[] {
  const msg = (id: string) => intl.formatMessage({ id })
  return [
    {
      id: 'demo-q1',
      survey_id: 'demo',
      text: msg('marketing.demo.q1.text'),
      type: 'RATING',
      required: true,
      order: 0,
      options: [],
      group_id: 'confiance',
      weight: 1,
      rating_labels: {
        '0': msg('marketing.demo.q1.rating0'),
        '1': msg('marketing.demo.q1.rating1'),
        '2': msg('marketing.demo.q1.rating2'),
        '3': msg('marketing.demo.q1.rating3'),
        '4': msg('marketing.demo.q1.rating4'),
        '5': msg('marketing.demo.q1.rating5'),
      },
      created_at: '2025-01-01T00:00:00Z',
      updated_at: '2025-01-01T00:00:00Z',
    },
    {
      id: 'demo-q2',
      survey_id: 'demo',
      text: msg('marketing.demo.q2.text'),
      type: 'BOOLEAN',
      required: true,
      order: 1,
      options: [],
      group_id: 'quotidien',
      weight: 1,
      created_at: '2025-01-01T00:00:00Z',
      updated_at: '2025-01-01T00:00:00Z',
    },
    {
      id: 'demo-q3',
      survey_id: 'demo',
      text: msg('marketing.demo.q3.text'),
      type: 'TEXT',
      required: false,
      order: 2,
      options: [],
      weight: 0,
      created_at: '2025-01-01T00:00:00Z',
      updated_at: '2025-01-01T00:00:00Z',
    },
  ]
}
